import { Component } from '@angular/core';

@Component({
  selector: 'app-cms',
  template: '<p></p>'
})
export class CMSComponent {
  constructor() { }
}
